const displayName = 'AdminTax';
const propTypes = {};
const defaultProps = {};
export default { displayName, propTypes, defaultProps };
